import React from "react";
import { Table, Button, Input, Select, Pagination, Space, Typography } from "antd";
import { Search, Filter, Upload, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;
const { Option } = Select;

const RefundIndex = () => {
    const navigate = useNavigate();

    const dataSource = [
        {
            key: '1',
            id: '37',
            orderId: '69',
            refundAmount: 120,
            billedTo: 'John Deo',
            refundDate: '2024-10-21 04:50:23',
        },
        {
            key: '2',
            id: '36',
            orderId: '68',
            refundAmount: 95,
            billedTo: 'John Deo',
            refundDate: '2024-10-14 10:58:55',
        },
        {
            key: '3',
            id: '35',
            orderId: '67',
            refundAmount: 80,
            billedTo: 'John Deo',
            refundDate: '2024-10-10 07:14:38',
        },
        {
            key: '4',
            id: '34',
            orderId: '64',
            refundAmount: 150,
            billedTo: 'Smith Maclain',
            refundDate: '2024-10-10 06:50:29',
        },
        {
            key: '5',
            id: '33',
            orderId: '66',
            refundAmount: 60,
            billedTo: 'John Deo',
            refundDate: '2024-10-10 06:45:55',
        },
        {
            key: '6',
            id: '32',
            orderId: '62',
            refundAmount: 45,
            billedTo: 'Sofia Deo',
            refundDate: '2024-10-07 07:06:03',
        },
        {
            key: '7',
            id: '31',
            orderId: '43',
            refundAmount: 200,
            billedTo: 'Sofia Deo',
            refundDate: '2024-10-07 06:46:01',
        },
    ];

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (text) => <Text style={{ color: '#64748b' }}>{text}</Text>,
        },
        {
            title: 'Order ID',
            dataIndex: 'orderId',
            key: 'orderId',
            render: (text) => <Text style={{ color: '#64748b' }}>{text}</Text>,
        },
        {
            title: 'Refunded',
            dataIndex: 'refundAmount',
            key: 'refundAmount',
            render: (text) => <Text style={{ color: '#64748b' }}>{text}</Text>,
        },
        {
            title: 'Billed To',
            dataIndex: 'billedTo',
            key: 'billedTo',
            render: (text) => <Text style={{ color: '#64748b' }}>{text}</Text>,
        },
        {
            title: 'Refund Date',
            dataIndex: 'refundDate',
            key: 'refundDate',
            render: (text) => <Text style={{ color: '#64748b' }}>{text}</Text>,
        },
        {
            title: 'Actions',
            key: 'actions',
            align: 'right',
            render: (_, record) => (
                <Button
                    type="text"
                    icon={<Eye size={18} color="#64748b" />}
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/sales/refunds/${record.id}`);
                    }}
                />
            ),
        },
    ];

    return (
        <div className="shipments-container" style={{ padding: '24px', background: '#fff', minHeight: '100vh' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <Title level={3} style={{ margin: 0, color: '#0f172a', fontWeight: 700 }}>Refunds</Title>
                <Button icon={<Upload size={16} />} style={{ display: 'flex', alignItems: 'center', borderRadius: '6px', color: '#64748b', fontWeight: 500, border: 'none', boxShadow: 'none' }}>
                    Export
                </Button>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '16px' }}>
                <Space size="large">
                    <Input
                        placeholder="Search"
                        suffix={<Search size={16} color="#94a3b8" />}
                        style={{ width: 250, borderRadius: '6px' }}
                    />
                </Space>
            </div>

            <Table scroll={{ x: 'max-content' }}
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                style={{ border: '1px solid #f1f5f9', borderRadius: '8px' }}
                className="reward-table-custom"
            // onRow={(record) => ({
            //     onClick: () => {
            //         navigate(`/sales/shipments/${record.id}`);
            //     }
            // })}
            />
        </div>
    );
};

export default RefundIndex;
